import {of as observableOf,  Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, Router } from '@angular/router';
import { CustomerService } from 'app/services/customer.service';
import { CustomerModel } from 'app/models/customer.model';

@Injectable()
export class CustomerResolver implements Resolve<CustomerModel> {

    constructor(private service: CustomerService, private router: Router) 
    {

    }

    resolve(route: ActivatedRouteSnapshot): Observable<CustomerModel> {
        return this.service.GetCustomer(route.params.id);
    }
}
